<template>
  <div class="notice-box">
    <p class="notice-box__message">
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.notice-box {
  padding: 8px;
  background-color: $gray-3;
  border: 1px solid $gray-2;
  border-radius: 4px;
  &__message {
    color: $gray-1;
    font-size: 1rem;
    line-height: 1.6;
    max-width: 100%;
  }
}
</style>
